import { InjectionToken } from '@angular/core';
import { SealedTradingQueryPort } from '../ports/sealed-trading-query.port';

export const SEALED_TRADING_QUERY_TOKEN = new InjectionToken<SealedTradingQueryPort>(
    'SealedTradingQueryPort'
);


